module.exports = __webpack_public_path__ + "img/shortcut_toff_off.1ed80fd6.svg";